/* eslint-disable react/jsx-no-bind */
//@flow

import * as React from 'react';
import LoginPageWrap from './components/LoginPageWrap';
import withRouteTracker from 'common/middleware/RouteTracker';
import Product from 'common/enums/Product';
import { ForgotPasswordForm } from 'platform/common/components/changePassword';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import useResolvedClientId from 'common/hooks/useResolvedClientId';
import { ProviderDataFetcher } from 'common/modules/provider';

const ForgotPasswordContainer = (): React.Node => {
    const history = useHistory();
    const location = useLocation();
    const { providerId } = useResolvedClientId();
    const queryParams = queryString.parse(location.search);
    const { username, token } = queryParams;
    const redirectToHome = () =>
        history.push({
            pathname: '/'
        });

    return (
        <ProviderDataFetcher providerId={providerId}>
            <LoginPageWrap marginTop="sm">
                <ForgotPasswordForm
                    username={username}
                    existingPassword={token}
                    onSuccess={redirectToHome}
                    onBack={redirectToHome}
                />
            </LoginPageWrap>
        </ProviderDataFetcher>
    );
};

export default (withRouteTracker(
    ForgotPasswordContainer,
    Product.PLATFORM
): React.AbstractComponent<{}>);
